import React from 'react';
import cn from 'classnames';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import Slider, { DefaultNextButton, DefaultPreviousButton } from '@wix/da-ds/pkg/Slider';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { BiData, BiContextProvidedValue } from '@wix/da-bi/pkg/events';
import noop from '../../../utils/noop';
import { toMediaSrcFile } from '../../../utils/DeviationMediaService/helpers';
import { getDeviationResourceType, getDeviationTitle } from '../../../DeviationViews/_helpers';
import { AttachmentUsageType } from '../../../redux/uploads/types';
import s from './AdditionalMediaSlider.scss';
export const DEFAULT_THUMB_SIZE = 40;
/** A Slider that allows selecting either one of a devation's
 *  additionalMedia or the deviation itself */ const AdditionalMediaSlider = ({ deviation, additionalMedia = [], thumbSize = DEFAULT_THUMB_SIZE, disabled, shouldBlur, className, selected, onSelect = noop })=>{
    if (!additionalMedia.length) {
        return null;
    }
    // todo: deviation is never the same object from render to render. why?
    const isDeviationSelected = (selected === null || selected === void 0 ? void 0 : selected.type) === deviation.type && (selected === null || selected === void 0 ? void 0 : selected.deviationId) === deviation.deviationId;
    const selectedIndex = additionalMedia.findIndex((media)=>media === selected);
    // not using a dumbo here so it will match attachment thumbs
    const deviationMediaType = deviation.media.types[0];
    const deviationThumbData = toMediaSrcFile(deviation, deviationMediaType);
    return /*#__PURE__*/ React.createElement(Slider, {
        className: cn(s['root'], className),
        slimSpacing: true,
        scrollToIndex: selectedIndex,
        smoothInitialScroll: false,
        onScrollBiData: {
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId,
            sectionname: BiContextProvidedValue
        },
        // todo: only using these button overrides to add an arrow className
        renderPrevButton: ({ onClick, className: arrowClassName })=>/*#__PURE__*/ React.createElement(DefaultPreviousButton, {
                className: cn(arrowClassName, s['slider-arrow']),
                arrowSize: IconSize.SMALL,
                onClick: onClick
            }),
        renderNextButton: ({ onClick, className: arrowClassName })=>/*#__PURE__*/ React.createElement(DefaultNextButton, {
                className: cn(arrowClassName, s['slider-arrow']),
                arrowSize: IconSize.SMALL,
                onClick: onClick
            })
    }, /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        key: 'deviation',
        style: {
            width: thumbSize,
            height: thumbSize
        },
        className: cn(s['thumb'], isDeviationSelected && s['selected-thumb']),
        disabled: disabled,
        onClick: ()=>onSelect(deviation),
        biData: BiData({
            evid: 310,
            deviationid: deviation.deviationId,
            rank: 0,
            usagetype: AttachmentUsageType.USAGETYPE_ORIGINAL_FILE
        })
    }, deviationThumbData && /*#__PURE__*/ React.createElement("img", {
        className: cn(s['thumb-image'], shouldBlur && s['blurred']),
        src: deviationThumbData.src,
        alt: getDeviationTitle(deviation)
    })), additionalMedia.map((attachment, idx)=>{
        const selectedMediaType = attachment.media.types[0];
        const thumbData = toMediaSrcFile(attachment, selectedMediaType);
        if (!thumbData) {
            return null;
        }
        return /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
            key: `additionalMedia-${attachment.fileId}`,
            style: {
                width: thumbSize,
                height: thumbSize
            },
            className: cn(s['thumb'], selected === attachment && s['selected-thumb']),
            disabled: disabled,
            onClick: ()=>onSelect(attachment),
            biData: BiData({
                evid: 310,
                deviationid: deviation.deviationId,
                fileid: attachment.fileId || 0,
                rank: idx + 1,
                usagetype: AttachmentUsageType.USAGETYPE_ADDITIONAL_IMAGE
            })
        }, /*#__PURE__*/ React.createElement("img", {
            className: cn(s['thumb-image'], shouldBlur && s['blurred']),
            src: thumbData.src,
            alt: attachment.filename
        }));
    }));
};
AdditionalMediaSlider.displayName = 'AdditionalMediaSlider';
export default AdditionalMediaSlider;

//# sourceMappingURL=AdditionalMediaSlider.js.map